import axios from 'axios'
import * as Config from '../config'
import { data } from 'autoprefixer'

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 1000000,
})

instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('adminPharmacyToken')
  config.headers.Authorization = `Bearer ${token}`

  return config
})

instance.interceptors.request.use(
  (request) => {
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const API = {
  commonApi: {
    //upload image
    postImage: (props) =>
      axios.post(`${Config.UPLOAD_IMAGE}?s3_path=${props.path}`, props.data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
  },

  authApi: {
    loginApiPharmacy: ({ data, headers }) =>
      instance.post(Config.LOGIN_PHARMACY, data, { headers }),
  },

  managePharmacy: {
    getProductListByProvider: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}&pharmacy_id=${data.id}${
        data?.urlAddOn || ''
      }`
      return instance.get(`${Config.PRODUCT_LISTING}?${last}`)
    },
    getProductTypeList: () => instance.get(`${Config.PRODUCT_TYPE_LIST}`),
    getPharmacyBookingOrderList: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}&pharmacy_id=${data.id}`
      return instance.get(`${Config.PHARMACY_BOOKING_LIST}?${last}`)
    },

    getProductDeatils: (data) => {
      return instance.get(`${Config.PHARMACY_PRODUCT_DEATILS}?product_id=${data}`)
    },
    getBookingDeatils: (data) => {
      return instance.get(
        `${Config.PHARMACY_BOOKING_LIST}?pharmacy_id=${data?.PharmacyId}&order_id=${data?.orderId}`,
      )
    },
    getAppointMentStatus: () => {
      return instance.get(`${Config.APPOINTMENT_STATUS}`)
    },

    updatePharmacyBookingList: ({ id, ...data }) =>
      instance.put(`${Config.PHARMACY_BOOKING_LIST}${id}/`, data),
    getProductListByProductType: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}&pharmacy_id=${data?.id}&product_type=${
        data?.product_type
      }${data?.urlAddOn || ''}`
      return instance.get(`${Config.PRODUCT_LISTING}?${last}`)
    },
    // get category for product type
    getAllTypePharmacyCategories: (data) => {
      return instance.get(`${Config.LIST_PRODUCT_CATEGORY}?&product_type=${data?.product_type}`)
    },
    addProductByProductType: (data) => {
      return instance.post(Config.PHARMACY_ADD_PRODUCT, data)
    },
    getPharmacySizes: () => instance.get(Config.PHARMACY_PRODUCT_SIZES),
    getListComposition: () => instance.get(Config.DRUG_COMPOSITION),
    getListSubTypes: () => instance.get(Config.PRODUCT_SUB_TYPE),
  },
}
